import * as formatHelper from "../../helpers/formatHelper";

/**
 * @class MainDatabase
 */
export default class MainDatabase {
    /**
     * @param {Number}  id
     * @param {Number}  minId
     * @param {String}  version
     * @param {String}  customerVersionId
     * @param {String}  customerVersion
     * @param {String}  creationDate
     * @param {String}  installationDate
     * @param {Number}  shotsCoef
     * @param {String}  moreInfo
     * @param {String}  changelog
     */
    constructor(
        id,
        minId,
        version,
        customerVersionId,
        customerVersion,
        creationDate = null,
        installationDate = null,
        shotsCoef = null,
        moreInfo = null,
        changelog = null
    ) {
        this._id = id;
        this._minId = minId;
        this._version = version;
        this._customerVersionId = customerVersionId;
        this._customerVersion = customerVersion;
        this._creationDate = creationDate;
        this._installationDate = installationDate;
        this._shotsCoef = shotsCoef;
        this._moreInfo = moreInfo;
        this._changelog = changelog;
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {Number}
     */
    get minId() {
        return this._minId;
    }

    /**
     * @param {Number} minId
     */
    set minId(minId) {
        this._minId = minId;
    }

    /**
     * @return {String}
     */
    get version() {
        return this._version;
    }

    /**
     * @param {String} version
     */
    set version(version) {
        this._version = version;
    }

    /**
     * @return {String}
     */
    get customerVersionId() {
        return this._customerVersionId;
    }

    /**
     * @param {String} customerVersionId
     */
    set customerVersionId(customerVersionId) {
        this._customerVersionId = customerVersionId;
    }

    /**
     * @return {String}
     */
    get customerVersion() {
        return this._customerVersion;
    }

    /**
     * @param {String} customerVersion
     */
    set customerVersion(customerVersion) {
        this._customerVersion = customerVersion;
    }

    /**
     * @return {String}
     */
    get creationDate() {
        return this._creationDate;
    }

    /**
     * @param {String} creationDate
     */
    set creationDate(creationDate) {
        this._creationDate = creationDate;
    }

    /**
     * @return {String}
     */
    get installationDate() {
        return this._installationDate;
    }

    /**
     * @param {String} installationDate
     */
    set installationDate(installationDate) {
        this._installationDate = installationDate;
    }

    /**
     * @return {Number}
     */
    get shotsCoef() {
        return this._shotsCoef;
    }

    /**
     * @param {Number} shotsCoef
     */
    set shotsCoef(shotsCoef) {
        this._shotsCoef = shotsCoef;
    }

    /**
     * @return {String}
     */
    get moreInfo() {
        return this._moreInfo;
    }

    /**
     * @param {String} moreInfo
     */
    set moreInfo(moreInfo) {
        this._moreInfo = moreInfo;
    }

    /**
     * @return {String}
     */
    get changelog() {
        return this._changelog;
    }

    /**
     * @param {String} changelog
     */
    set changelog(changelog) {
        this._changelog = changelog;
    }

    /**
     * @return {Object}
     */
    clone() {
        let clone = new MainDatabase(
            this._id,
            this._minId,
            this._version,
            this._customerVersionId,
            this._customerVersion,
            this._creationDate,
            this._installationDate,
            this._shotsCoef,
            this._moreInfo,
            this._changelog
        );

        return clone;
    }

    /**
     * @return{String}
     */
    formatCreationDate() {
        if (this._creationDate === null) {
            return "";
        }

        return formatHelper.formatDateTimeUtc(this._creationDate);
    }

    /**
     * @return{String}
     */
    formatInstallationDate() {
        if (this._installationDate === null) {
            return "";
        }

        return formatHelper.formatDateTimeUtc(this._installationDate);
    }

    /**
     * @return {String}
     */
    toString() {
        return "MainDatabase (" + this._id + ")";
    }
}
